<avla-modal [name]="getModalName" type="right"
    [icon]="{ type: 'class', icon: 'close', class: 'material-symbols-rounded' }" [onClose]="reInit.bind(this)">
    <div *ngIf="response === 'onInit'"
        class="avla_modal_section__header text-center text-dark-gray  max-w-[400px] mx-auto font-semibold">
        <span class="material-symbols-rounded text-[32px] text-light-blue font-semibold">
            person_add
        </span>
        <h5 class="text-2xl mt-9">
            Crea tu cuenta AVLA
        </h5>
        <p class="font-light text-m mt-2">Regístrate con nosotros y podrás contar con todos los servicios que ofrecemos
            para ti</p>
    </div>
    <div class="avla_modal_section__body" [ngClass]="{'max-h-[70vh] overflow-y-scroll pb-40': height < 900}">
        <form *ngIf="response === 'onInit'" [formGroup]="createAccountForm" class="flex flex-col gap-6 mt-6">
            <p class="mt-6 text-base">Información personal</p>
            <avla-input [form]="createAccountForm" id="rut" type="rut" label="RUT" [required]="true"
                [errorMessage]="createAccountForm.get('rut').hasError('required') ? 'Requerido' : 'RUT inválido'">
            </avla-input>
            <avla-input [form]="createAccountForm" id="name" type="text" label="Nombre Completo"
                [disabled]="fullName !== ''" [required]="fullName === ''">
            </avla-input>
            <avla-input [form]="createAccountForm" id="email" type="text" label="Email" [required]="true"
                [errorMessage]="createAccountForm.get('email').hasError('required') ? 'Requerido' : 'Email inválido'">
            </avla-input>
            <p class="mt-2 text-base">Información de la empresa</p>
            <avla-input [form]="createAccountForm" id="rutCompany" type="rut" label="RUT" [required]="true"
                [errorMessage]="createAccountForm.get('rut').hasError('required') ? 'Requerido' : 'RUT inválido'">
            </avla-input>
            <avla-input [form]="createAccountForm" id="company" type="text" label="Nombre Completo/Razón Social"
                [disabled]="fullName !== ''" [required]="fullName === ''">
            </avla-input>
            <avla-phone [codes]="codes" [form]="createAccountForm" label="Teléfono" id="phone"
                errorMessage="Télefono inválido" [arrow]="{
                    icon: 'expand_more',
                    type: 'class',
                    class: 'material-symbols-outlined'
                }"></avla-phone>
            <div *ngIf="!hiddenV2" class="mx-auto">
                <re-captcha id="token" name="token" #recaptcha="ngModel" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="token" required
                    [class.is-invalid]="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)"></re-captcha>
            </div>
            <avla-button class="avla-btn-login" theme="primary" [isFluid]="true" (click)="createAccount()"
                [disabled]="createAccountIsDisabled" label="Solicitar" [icon]="{
                type: 'class',
                icon: 'arrow_forward',
                class: 'material-symbols-rounded',
                position: 'right'
            }">
            </avla-button>
        </form>
        <div *ngIf="response === 'success'" class="flex flex-col gap-11 items-center max-w-[333px] mx-auto mt-28">
            <span class="material-symbols-rounded text-[44px] text-gray-2 font-semibold">
                task_alt
            </span>
            <p class="text-2xl font-semibold text-light-blue">
                ¡Bien!
            </p>
            <p class="text-lg text-dark-gray text-center">
                Su solicitud fue enviada con éxito
            </p>
            <avla-button class="avla-btn-purp avla-btn-flat-label-md" theme="primary" (click)="closeModal()"
                label="Continuar">
            </avla-button>
            <div class="flex gap-4">
                <span class="material-symbols-rounded">
                    email
                </span>
                <p class="text-m text-gray-2">Muy pronto un ejecutivo se comunicará contigo para comentarte sobre el proceso de creación de tu cuenta.</p>
            </div>
        </div>
        <div *ngIf="response === 'fail'" class="flex flex-col gap-11 items-center max-w-[284px] mx-auto mt-28">
            <span class="material-symbols-rounded text-6xl text-fail font-semibold">
                cancel
            </span>
            <p class="text-2xl font-semibold text-fail">
                ¡Lo sentimos!
            </p>
            <p class="text-lg font-medium text-gray-2 text-center">
                Su solicitud no tuvo éxito. Inténtalo de nuevo cuando estés listo
            </p>
            <div class="flex justify-between w-full">
                <div class="w-[120px]">
                    <avla-button class="avla-btn-purp avla-btn-flat-label-md" theme="primary" (click)="createAccount()"
                        label="Reintentar" [isFluid]="true">
                    </avla-button>
                </div>
                <div class="w-[120px]">
                    <avla-button class="avla-btn-flat-label-md" theme="secondary" (click)="closeModal()" label="Salir"
                        [isFluid]="true">
                    </avla-button>
                </div>
            </div>
        </div>
    </div>
</avla-modal>